export default __webpack_public_path__ + "static/media/heart.b9cb45de.svg";